import styled, { css } from 'styled-components';

import { mediaSmallOrTiny, mediaWide } from '@xingternal/layout-tokens';
import { space3XL, spaceL, spaceM, spaceS, spaceXL, xdlColorHover } from '@xingternal/tokens';

import { JobTeaserListItem as JobTeaserListItemComponent } from '@/components/job-teaser';

import { LoggedOutBanner as LoggedOutBannerComponent } from './logged-out-banner';
import { ProJobsUpsellBanner as ProJobsUpsellBannerComponent } from './projobs-upsell-banner';

export const JobTeaserListItem = styled(JobTeaserListItemComponent)`
  & > a {
    padding: ${spaceL} 0;

    @media ${mediaWide} {
      padding: ${spaceXL} ${spaceM};

      &:hover {
        background-color: ${xdlColorHover};
      }
    }
  }
`;

export const LoggedOutBanner = styled(LoggedOutBannerComponent)`
  margin: ${spaceXL} 0;
`;

export const ProJobsUpsellBanner = styled(ProJobsUpsellBannerComponent)`
  margin: ${spaceS} 0;
  padding: ${spaceL};

  @media ${mediaWide} {
    margin: ${spaceXL} 0;
    padding: ${spaceL} ${spaceXL};
  }
`;

export const List = styled.ul<{ $isSearchFallback: boolean }>`
  list-style-type: none;
  padding: 0;
  margin: 0;

  ${({ $isSearchFallback }) =>
    $isSearchFallback &&
    css`
      @media ${mediaSmallOrTiny} {
        margin-bottom: ${space3XL};
      }
    `}
`;
